import {
  withTranslation,
} from 'react-i18next';

import ProfileFieldsView from './ProfileFieldsView';

const TranslatedComponent = withTranslation()(ProfileFieldsView);

const Component = TranslatedComponent;

export default Component;
